module.exports = __webpack_public_path__ + "static/media/christian.b5556b2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/crew/christian.jpg
// module id = 610
// module chunks = 0